// /utils/orderPayload.js

/**
 * Generate order payload for real or virtual brokers.
 *
 * @param {'real'|'virtual'} isVirtual - Mode to determine broker type.
 * @param {Array} selectedData - List of selected order data.
 * @param {string} marketType - Either "NRML" or another type.
 * @param {Object} limitOrderStates - Order type (MARKET/LIMIT) state per symbol.
 * @param {Object} selectedSymbol - Selected symbol info.
 * @param {string} broker - Broker name for real orders.
 * @param {string} access_token - Auth token.
 * @param {string} client_id - Client ID.
 * @param {Object} orderTypes - Order types (cover/bracket) for each row.
 * @param {Object} inputModes - Input modes (percentage/absolute) for each row.
 * @returns {Object} Final payload to send.
 */
const generateOrderPayload = ({
  isVirtual = false,
  selectedData,
  marketType,
  limitOrderStates,
  selectedSymbol,
  broker,
  access_token,
  client_id,
  orderTypes = {},
  inputModes = {},
}) => {
  const orderList = selectedData.map((currData, ind) => {
    // Determine stop-loss type and value
    let sl_type = null;
    let sl_value = null;

    if (currData.stoploss && currData.stoploss.trim() !== "") {
      sl_type =
        inputModes[ind]?.stoploss === "percentage"
          ? "% Difference"
          : "Abs value";
      sl_value = parseFloat(currData.stoploss) || null;
    }

    // Determine target type and value (only for bracket orders)
    let target_type = null;
    let target_value = null;

    if (
      orderTypes[ind] === "bracket" &&
      currData.target &&
      currData.target.trim() !== ""
    ) {
      target_type =
        inputModes[ind]?.target === "percentage" ? "% Difference" : "Abs value";
      target_value = parseFloat(currData.target) || null;
    }

    return {
      isBuy: currData.isBuy,
      isCall: currData.isCALL,
      isFut: currData.isFuture || false,
      code: currData.code,
      exchange: currData.exchange,
      productType: marketType === "NRML" ? "NRML" : "MIS",
      orderType: !limitOrderStates?.[selectedSymbol?.scrip]?.[ind]
        ? "MARKET"
        : "LIMIT",
      quantity: currData.lotSize * currData.lot_multiplier,
      price: currData.price,
      freeze_qty: currData.freeze_qty,
      strike: currData.strike,
      expiry: currData.expiry,
      tradingSymbol: currData.tradingSymbol,
      lot_multiplier: currData.lot_multiplier,
      scrip: currData.scrip,
      sl_type,
      sl_value,
      target_type,
      target_value,
    };
  });

  const payload = {
    order_list: orderList,
    broker: isVirtual ? "virtual" : broker,
    access_token,
    client_id,
  };

  return payload;
};

export default generateOrderPayload;
